// extracted by mini-css-extract-plugin
export default {"container":"FullScreenCardContainer_container__ekSZB","Card":"FullScreenCardContainer_Card__20n4-"};